import { FC } from 'react';
import appRoutes from 'config/appRoutes';
import { profileRequestOverdueSlice } from '../../store/profileReports';
import OverdueReport from './OverdueReport';
import { ProfileDateRangeProps } from './useProfileDateRange';

interface RequestOverdueReportProps extends ProfileDateRangeProps {
  userUuid: string;
}

const RequestOverdueReport: FC<RequestOverdueReportProps> = ({ userUuid, dateRange, onDateRangeChange }) => (
  <OverdueReport
    storeSlice={profileRequestOverdueSlice}
    userUuid={userUuid}
    dateRange={dateRange}
    onDateRangeChange={onDateRangeChange}
    rowKey="request_uuid"
    titleColumn={{ title: 'Request', dataIndex: 'request_subject' }}
    titleLink={(row) => `${appRoutes.REQUESTS}/${row.request_uuid}`}
    searchField="request_subject"
    searchPlaceholder="Search request"
    showSearch={false}
    eventDate={{ title: 'End date', single: 'target_date', old: 'old_target_date', next: 'new_target_date' }}
    countLabel="entries"
    headerTitle="Request overdue report"
    headerSubtitle="Requests that have been overdue with their events"
  />
);

export default RequestOverdueReport;
